import React from "react";
import { Link } from "react-router-dom";
import Countdown from "../Countdown";

export default function NewItemsCard({ item }) {
  return (
    <div className="keen-slider__slide">
      <div className="nft__item">
        <div className="author_list_pp">
          <Link to={`/author/${item.authorId}`}>
            <img className="lazy" src={item.authorImage} alt="" />
            <i className="fa fa-check"></i>
          </Link>
        </div>
        {item.expiryDate && <Countdown expiryDate={item.expiryDate} />}
        <div className="nft__item_wrap">
          <Link to={`/item-details/${item.nftId}`}>
            <img
              src={item.nftImage}
              className="lazy nft__item_preview"
              alt=""
            />
          </Link>
        </div>
        <div className="nft__item_info">
          <Link to={`/item-details/${item.nftId}`}>
            <h4>{item.title}</h4>
          </Link>
          <div className="nft__item_price">{item.price}</div>
          <div className="nft__item_like">
            <i className="fa fa-heart"></i>
            <span>{item.likes}</span>
          </div>
        </div>
      </div>
    </div>
  );
}